export default "__VITE_ASSET__CeR2lFLw__"